// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TC-z","modalContent":"UC-z","header":"VC-z","close":"WC-z"};